export function isValidDate(date) {
    return date instanceof Date && !Number.isNaN(date.getTime());
}
export function isValidRange([start, end] = [null, null]) {
    return (isValidDate(start) && isValidDate(end) && start.getTime() < end.getTime());
}
